import { defineStore } from 'pinia'

export const usePopup = defineStore('popup', {
  state: () => ({
    materialPopup: false,
    stitchTypePopup: false,
    stitchTypeSinglePopup: false,
    stitchDistributionPopup: false,
    buttonsPopup: false,
    stitchesPopup: false,
    bigsizealertPopup: false,
    infoPopup: false,
  }),
})
